<script lang="ts" setup>
const { $api } = useNuxtApp()
const router = useRouter()
const { t } = useI18n()
const { locale } = useI18n()
const lang = computed(() => locale.value as 'en' | 'id')


const locationFilter = {
    "province": {
        "placeholder": {
            "en": "All Provinces",
            "id": "Semua Provinsi"
        }
    }
}

const [{ data: provinceData }, { data: heroData }] = await Promise.all([
    $api.master.getProvinces({ query: { country_id: 1 } }),
    $api.landingPage.getHero(),
])
const provinces = provinceData.value.data
const hero = heroData.value.data

// const hero = ref()

const filter = ref({
    search: null,
    province_id: null
})

const searchJob = () => {
    if (filter.value.search || filter.value.province_id) {
        const query = Object.fromEntries(
            Object.entries(filter.value).filter(
                ([_, v]) => v != null && v !== '' && v !== undefined
            )
        )
        router.push({
            name: 'job',
            query: query
        })
    }
}
</script>

<template>
    <div class="hero">
        <svg class="hero__art-one animate-shape" width="219" height="247" viewBox="0 0 219 247" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-88.5238 139.735C-71.707 114.09 -45.784 95.7815 -15.9886 88.5064C13.8069 81.2314 45.2551 85.5317 72.0067 100.539C98.7583 115.547 118.82 140.143 128.142 169.363C137.465 198.583 135.352 230.249 122.232 257.968L196.362 299.555C220.552 252.16 225.451 197.24 210.035 146.305C194.618 95.3714 160.082 52.3787 113.665 26.3395C67.2492 0.300241 12.557 -6.76361 -38.9464 6.62869C-90.4498 20.021 -134.765 52.8295 -162.604 98.177L-88.5238 139.735Z" fill="#FF1D25"/>
        </svg>
        <svg class="hero__art-two animate-shape-top" width="311" height="233" viewBox="0 0 311 233" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M402.8 -11.0723C400.186 26.6537 383.353 61.9831 355.699 87.7831C328.045 113.583 291.63 127.931 253.806 127.931C215.982 127.931 179.567 113.583 151.913 87.7831C124.259 61.9831 107.426 26.6537 104.813 -11.0723H0C2.57969 54.4915 30.4446 116.511 77.7537 161.987C125.063 207.462 188.143 232.862 253.77 232.862C319.398 232.862 382.478 207.462 429.787 161.987C477.096 116.511 504.961 54.4915 507.541 -11.0723H402.8Z" fill="#FF1D25"/>
        </svg>
        <img class="hero__top-left" fetchpriority="high" src="/images/landing-page/hero/hero-top-left.webp" alt="Hero Image">
        <img class="hero__bottom-right" fetchpriority="high" src="/images/landing-page/hero/hero-bottom-right.webp" alt="Hero Image">
        <VContainer>
           
            <div class="hero__inner">
                <div class="hero__info-container">
                    <h1 class="hero__title">
                        {{ hero.title[lang] }}
                    </h1>
                    <p class="hero__subtitle">
                        {{ hero.description[lang] }}
                    </p>
                </div>
                
                <VRow class="hero__form" no-gutters>
                    <div class="hero__form-location">
                        <VAutocomplete 
                           :placeholder="locationFilter.province.placeholder[lang]"
                            v-model="filter.province_id"
                            :items="provinces"
                            item-value="id"
                            item-title="name"
                            bg-color="surface"
                            density="compact"
                            prepend-inner-icon="ri-map-pin-line"
                            clearable
                            class="hero__province-select" 
                        ></VAutocomplete
                    ></div>
                    <div class="hero__form-search">
                        <VTextField
                            v-model="filter.search"
                            :placeholder="t('search_by_keywords')"
                            density="compact"
                            bg-color="surface"
                            clearable
                        />
                        <VBtn color="error" @click="searchJob">
                            {{ t('search') }}
                        </VBtn>
                    </div>
                </VRow>
            </div>
        </VContainer>
    </div>
</template>

<style lang="scss" scoped>
.hero {
    position: relative;
    min-height: 700px;
    background-color: #211F1F;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: hidden;
    @media only screen and (max-width: 1399.98px) {
        height: 100vh;
        min-height: 500px;
    }

    &__top-left{
        position: absolute;
        top: 80px;
        left: 0;
        z-index: 0;
        height: auto;
        @include vwUnit('max-width',653, 300);
        @media only screen and (max-width: 767.98px) {
            max-width: 200px;
        }
    }

    &__bottom-right{
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 0;
        height: auto;
        @include vwUnit('max-width',731, 400);
        @media only screen and (max-width: 767.98px) {
            max-width: 200px;
        }
    }

    &__art-one{
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 0;
        @include vwUnit('max-width',219, 150);
        height: auto;
    }
    &__art-two{
        position: absolute;
        top: 60px;
        right: 0;
        z-index: 0;
        height: auto;
        @include vwUnit('max-width',311, 150);
    }

    &__inner{
        position: relative;
        z-index: 10;
        @include vwUnit('padding-top',180, 100);
        @include vwUnit('max-width',1100, 600);
        margin: 0 auto;

        @media only screen and (max-width: 1399.98px) {
            max-width: 1000px;
        }

        @media only screen and (max-width: 991.98px) {
            max-width: 100%;
        }
    }

    &__info-container{ 
        color: #fff;
    }

    &__title{
        color: #fff;
        @include vwUnit('font-size',52,52);
        @include vwUnit('margin-bottom',5,4);
        font-family: $primary-font;
        line-height: 1.1;
        font-weight: 700;

        @media only screen and (max-width: 991.98px) {
            max-width: 80%;
            margin-left: auto;
            margin-right: auto;
        }
        @media only screen and (max-width: 767.98px) {
             max-width: 100%;
             font-size: 30px;
        }
    }

    &__subtitle{
        font-family: $primary-font-light;
        @include vwUnit('font-size',20,20);
        @include vwUnit('margin-bottom',40,40);
        line-height: 1.5;
        font-weight: 400;
        max-width: 75%;
        margin-left: auto;
        margin-right: auto;
        @media only screen and (max-width: 1399.98px) {
            font-size: 20px;
        }

        @media only screen and (max-width: 767.98px) {
             max-width: 100%;
             font-size: 16px;
        }
    }

    &__form{
        display: grid;
        grid-template-columns: 251px 1fr;
        gap: 10px;

        @media only screen and (max-width: 991.98px) {
             grid-template-columns: 172px 1fr;
        }
        @media only screen and (max-width: 767.98px) {
             grid-template-columns: 1fr;
              gap: 10px;
        }
    }

    &__form-search{
        display: flex;
        align-items: center;
        gap: 10px;
        @media only screen and (max-width: 756.98px) {
            display: grid;
        }
    }

    &__province-select{
        .v-input__control {
            align-items: center;
            height: 63px;
        }

        .v-field{
            height: 63px;
            display: flex;
            align-items: center;
        }
    }

    @media only screen and (min-width: 992px) {
        :deep(.v-input__control ) {
            align-items: center;
            height: 63px;
        }

        :deep(.v-field ) {
            height: 63px;
            display: flex;
            align-items: center;
        }

        :deep(.v-btn ) {
            min-height: 63px;
        }

        :deep(.v-autocomplete__selection ) {
            font-size: 16px;
        }

        :deep(.v-autocomplete__selection ) {
            font-size: 18px;
        }

        :deep(.v-btn) {
            min-width: 160px;
        }
    }
}
</style>
